import { render, staticRenderFns } from "./ManagementCompanyPopup.vue?vue&type=template&id=a8a8c1d4&scoped=true&"
import script from "./ManagementCompanyPopup.vue?vue&type=script&lang=ts&"
export * from "./ManagementCompanyPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementCompanyPopup.vue?vue&type=style&index=0&id=a8a8c1d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a8c1d4",
  null
  
)

export default component.exports